import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/tailwind.css'
import permissionsMixin from './mixins/permissionsMixin'

// Directives
import Closable from "./directives/closable";

// Buttons
import PrimaryButton from "./components/ui/PrimaryButton";
import EditButton from "./components/ui/EditButton";
import DeleteButton from "./components/ui/DeleteButton";

// Custom
import CustomSelect from "./components/ui/CustomSelect";
import CustomInputSelect from "./components/ui/CustomInputSelect";
import CustomSearch from "./components/ui/CustomSearch";
import OptionsMenu from "./components/ui/OptionsMenu";
import CustomDateInput from "./components/ui/CustomDateInput";
import Tooltip from "./components/ui/Tooltip";

// Visual Hierarchy
import StatusBadge from "./components/ui/StatusBadge";
import SectionHeader from "./components/ui/SectionHeader";
import DetailField from "./components/ui/DetailField";
import CardHeader from "./components/ui/CardHeader";

// Icons
import LoaderIcon from "./icons/LoaderIcon";
import EditIcon from "./icons/EditIcon";
import DeleteIcon from "./icons/DeleteIcon";
import ArrowIcon from "./icons/ArrowIcon";
import BackIcon from "./icons/BackIcon";
import CloseIcon from "./icons/CloseIcon";

const app = createApp(App);

app.directive('closable', Closable);

app.component('primary-button', PrimaryButton);
app.component('edit-button', EditButton);
app.component('delete-button', DeleteButton);

app.component('custom-select', CustomSelect);
app.component('custom-input-select', CustomInputSelect);
app.component('custom-search', CustomSearch);
app.component('options-menu', OptionsMenu);
app.component('custom-date-input', CustomDateInput);
app.component('tooltip', Tooltip);

app.component('status-badge', StatusBadge);
app.component('section-header', SectionHeader);
app.component('detail-field', DetailField);
app.component('card-header', CardHeader);

app.component('loader-icon', LoaderIcon);
app.component('edit-icon', EditIcon);
app.component('delete-icon', DeleteIcon);
app.component('arrow-icon', ArrowIcon);
app.component('back-icon', BackIcon);
app.component('close-icon', CloseIcon);

app.mixin(permissionsMixin);

app.use(store);

(async () => {
  await store.dispatch("loadUser");

  app.use(router);

  app.mount('#app');
})();
